<div class="radio">
	<label [ngClass]="{'radio__label--hidden': hideLabel}"  class="radio__label" [for]="name + '-' + id" (click)="toggleValue()">{{ label }}</label>
	<input class="radio__input" [id]="name + '-' + id" [name]="name || id" [value]="id"
		   type="radio" [checked]="selected" (change)="emitChange()">
	<div class="radio__bullet" (click)="toggleValue()"></div>
</div>
